import {
  FETCH_USER_DOMAIN_INVITATIONS_SUCCESS,  
  FETCH_USER_DOMAIN_INVITATIONS_ERROR,
  ACCEPT_USER_DOMAIN_INVITATIONS_SUCCESS,
  ACCEPT_USER_DOMAIN_INVITATIONS_ERROR,
} from '../actions/domains';

const INITIAL_STATE = { invitations:[], errors:[] };

const pendingDomainInvitations = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_USER_DOMAIN_INVITATIONS_SUCCESS:
      return {
        errors: [],
        invitations : action.payload.items
      };
    case FETCH_USER_DOMAIN_INVITATIONS_ERROR:
      return {
        errors: action.error,
        invitations: []
      };
    case  ACCEPT_USER_DOMAIN_INVITATIONS_SUCCESS:
        return { 
          ...state, 
          invitations: state.invitations.filter(invitation => invitation.id !== action.domainInvitationId) 
        }
    case ACCEPT_USER_DOMAIN_INVITATIONS_ERROR:
      return {
        ...state,
        errors: action.error,
      };
    default:
        return state;
  }
}

export default pendingDomainInvitations;


// WEBPACK FOOTER //
// ./src/reducers/pendingDomainInvitations.js